export default __webpack_public_path__ + "static/media/3-1.12a2fcfe.png";